module.exports = __webpack_public_path__ + "img/sqe_smart.a60e2851.png";